<div class="seatmap__seat-wrapper" [tooltip]="INDRA_tooltipSeat()">
    <ng-container *ngIf="!seat.missing && (cabin.location == 'F' || cabin.location == 'C')">
        <!-- {{ seat.column }} -->
    </ng-container>
    <div class="seatmap__seat__table-left" *ngIf="!seat.missing && seat.tableLeft && !seat.empty"></div>
    <div class="seatmap__seat__table-right" *ngIf="!seat.missing && seat.tableRight && !seat.empty"></div>

    <app-svg class="emergency-exit--icon" [ngClass]="{'exit-class': seat.available == false}" svg="icons.svg#general--arrow--long_right" aria-hidden="true" [alt]="'addMoreSidebars.seatmap.alt.emergencyExit' | ibeadmin: 'sync'">
    </app-svg>
    <span *ngIf="seatPassenger">{{ seatPassenger }}</span>
    <app-svg class="seatmap__seat-icon" *ngIf="hasIcon" svg="icons.svg#{{ seatIcon }}" aria-hidden="true" [alt]="seatIcon + ' icon'">
    </app-svg>
</div>